import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import Survey from '../Pages/Survey/Survey';
import Login from '../Pages/Login/Login';
import Reset from '../Pages/Reset/Reset';
import Home from '../Pages/Home/Home';
import { ProtectRoute } from '../Components/Auth/ProtectRoute';

function router() {
    return (
        <>
            <BrowserRouter>
                <Switch>
                    <Route path={"/survey"} component={Survey} exact />
                    <Route path={"/"} component={Login} exact />
                    <Route path={"/reset/password"} component={Reset} exact />
                    <ProtectRoute path={"/home"} component={Home} />
                </Switch>
            </BrowserRouter>
        </>
    )
}

export default router